import { Navigate, useParams } from 'react-router-dom';
import { GamesSection } from './GamesSection';

/** The Games tab (2026-11-03): the games list, always open, as its own page. */
export function GamesPage(): JSX.Element {
  return (
    <div className="flex flex-col gap-4 py-6">
      <GamesSection standalone />
    </div>
  );
}

/** `/apps/game/:id` from before the Games tab existed → `/games/:id`. */
export function LegacyGameRedirect(): JSX.Element {
  const { gameId } = useParams<{ gameId: string }>();
  return <Navigate to={gameId ? `/games/${gameId}` : '/games'} replace />;
}
